import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: { author: 'Автор' },
  en: { author: 'Author' },
})
